var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RangeSlider',{attrs:{"min":_vm.min,"max":_vm.max,"label":_vm.label,"step":_vm.step,"sliderColor":_vm.sliderColor,"trackColor":_vm.trackColor,"value":_vm.modelValue},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }